import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import LumerAIPageRouteView from './pages/LumeraiPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantSettingsIndex from './assistants/settings/Settings.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import CustomToolsIndex from './tools/Index.vue';
import AlertsIndex from './alerts/Index.vue';

const meta = {
  permissions: ['administrator', 'agent', 'lumerai_manage'],
  featureFlag: FEATURE_FLAGS.LUMERAI,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
  module: 'ia',
};

const metaCustomTools = {
  permissions: ['administrator', 'agent', 'lumerai_manage'],
  featureFlag: FEATURE_FLAGS.LUMERAI_CUSTOM_TOOLS,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
  module: 'ia',
};

const metaV2 = {
  permissions: ['administrator', 'agent', 'lumerai_manage'],
  featureFlag: FEATURE_FLAGS.LUMERAI_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
  module: 'ia',
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'lumerai_assistants_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'lumerai_assistants_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'lumerai_tools_index',
    meta: metaCustomTools,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'lumerai_assistants_scenarios_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'lumerai_assistants_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'lumerai_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'lumerai_assistants_responses_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'lumerai_assistants_settings_index',
    meta,
  },
  // Settings sub-pages (guardrails and guidelines)
  {
    path: frontendURL(
      'accounts/:accountId/lumerai/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'lumerai_assistants_guardrails_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/lumerai/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'lumerai_assistants_guidelines_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'lumerai_assistants_create_index',
    meta: {
      permissions: ['administrator', 'agent', 'lumerai_manage'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/alerts'),
    component: AlertsIndex,
    name: 'lumerai_alerts_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/flows'),
    component: () => import('./flows/Index.vue'),
    name: 'lumerai_flows',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/flows/:flowId/editor'),
    component: () => import('./flows/Editor.vue'),
    name: 'lumerai_flows_editor',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumerai/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'lumerai_assistants_index',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/lumerai'),
    component: LumerAIPageRouteView,
    redirect: to => {
      return {
        name: 'lumerai_assistants_index',
        params: {
          navigationPath: 'lumerai_assistants_responses_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
